export default {
    bind(el, binding) {
        const { value } = binding
        const observer = new IntersectionObserver((e) => {
            e.forEach((d) => {
                if (d.intersectionRatio > 0) {
                    // console.log('appear');
                } else {
                    // console.log('disappear',this);
                    value && value()

                }
            });
        });
        el.__observer__ = observer
        observer.observe(el);
    },
    unbind(el) {
        if(el.__observer__) {
            el.__observer__.disconnect()
            el.__observer__ = null
        }
    }
};



// WEBPACK FOOTER //
// ./src/directives/drop-controller.js